/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsTempSelectionToggleRight: {
  name: 'temp-selection-toggle-right';
  data: string;
} = {
  name: 'temp-selection-toggle-right',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path fill-rule="evenodd" clip-rule="evenodd" d="M6 2.5a5.5 5.5 0 1 0 0 11h4a5.5 5.5 0 1 0 0-11H6ZM1.5 8A4.5 4.5 0 0 1 6 3.5h4a4.5 4.5 0 1 1 0 9H6A4.5 4.5 0 0 1 1.5 8Zm8 0a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0ZM11 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5Z" fill="currentColor"/></svg>`,
};
